// Détecte les tronçons "sans réseau mobile" : écart de temps anormal entre 2 points
// consécutifs (le boîtier n'a pas transmis pendant la coupure -> trait droit).
export function noSignalSegments(points, thresholdSec = 120) {
  const segs = [];
  const pts = points || [];
  for (let i = 1; i < pts.length; i++) {
    const a = pts[i - 1], b = pts[i];
    if (!a?.timestamp || !b?.timestamp) continue;
    const dt = (new Date(b.timestamp) - new Date(a.timestamp)) / 1000;
    if (dt > thresholdSec) {
      segs.push({ positions: [[a.lat, a.lon], [b.lat, b.lon]], gapMin: Math.max(1, Math.round(dt / 60)), from: a.timestamp, to: b.timestamp });
    }
  }
  return segs;
}
